import { useRef } from 'react';
import type { MouseEvent } from 'react';
import classNames from 'classnames';

import { MeatballsIcon } from '../../icons';
import IconButton from '../IconButton';
import OverlayPopover from '../OverlayPopover';

import styles from './_index.module.scss';

export interface ActionOverlayPopoverProps {
  'aria-label'?: string;
  children: React.ReactNode;
  hasArrow?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onHide?: () => void;
}

const ActionOverlayPopover = ({
  'aria-label': ariaLabel = 'More actions',
  children,
  hasArrow,
  isActive,
  isDisabled,
  onClick = () => undefined,
  onHide,
}: ActionOverlayPopoverProps) => {
  const popoverRef = useRef<HTMLButtonElement>(null);

  return (
    <div className={styles['action-overlay-popover']}>
      <IconButton
        aria-expanded={Boolean(isActive)}
        aria-haspopup="menu"
        aria-label={ariaLabel}
        className={classNames(styles['action-overlay-popover-ellipsis'], {
          [styles['is-active']]: isActive,
          [styles['is-disabled']]: isDisabled,
        })}
        data-testid="action-overlay-popover-icon"
        isDisabled={isDisabled}
        onClick={onClick}
        ref={popoverRef}
        type="button"
      >
        <MeatballsIcon />
      </IconButton>
      {isActive && (
        <OverlayPopover
          hasArrow={hasArrow}
          isActive={isActive}
          onHide={onHide}
          target={popoverRef?.current}
        >
          {children}
        </OverlayPopover>
      )}
    </div>
  );
};

export default ActionOverlayPopover;
